import './styles.css';

import React, { Component } from 'react';
import LandingPageHeader from "../../components/LandingPageHeader/LandingPageHeader";
import Content from "../../content/Content";
import HeaderText from "../../components/HeaderText/HeaderText";
import InformationLabel from "../../components/InformationLabel/InformationLabel";
import InformationLabelContentList from "../../components/InformationLabelContentList/InformationLabelContentList";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import Footer from "../../components/Footer/Footer";
import Constants from "../../constants/Constants";
import {checkAuth, xhrGetCoinRateInfoAndAuth} from "../../services/BaseServiceHandler";
import DataPanelLoadingView from "../../components/LoadingViews/DataPanelLoadingView";
import Gutter from '../../components/Gutter/Gutter';
import BtnOutline from '../../components/Buttons/BtnOutline/BtnOutline';
import GetMoreProfilesModal from '../../components/GetMoreProfilesModal/GetMoreProfilesModal';

const btnCustomStyle = {
    width: '170px'
};

class FaqFreelancer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            coinRate: 0,
            type: null,
            rightView: 1,
            isActiveQuestion1: true,
            width: window.innerWidth,
            isAuthenticatedUser: false,
            showGetMoreProfilesModal: false,
            serverCallStatus : Constants.REQUEST_STATS.PENDING,
        };
        this.refGetInTouch=null;
    }

    componentWillMount() {  
        const params = new URLSearchParams(this.props.location.search);
        if(params) {
            const faqItems = params.get(Constants.FAQ_SEARCH_PARAMS);
            if(faqItems) {
                if(faqItems === Constants.FAQ_QUERY_PARAMS.ABOUT) {
                    this.setState({
                        rightView: 1
                    });
                    this.markActive(parseInt(1));
                }
                if(faqItems === Constants.FAQ_QUERY_PARAMS.START) {
                    this.setState({
                        rightView: 2
                    });
                    this.markActive(parseInt(2));
                }
                if(faqItems === Constants.FAQ_QUERY_PARAMS.PREMIUM) {
                    this.setState({
                        rightView: 3
                    });
                    this.markActive(parseInt(3));
                }
                if(faqItems === Constants.FAQ_QUERY_PARAMS.PRICING) {
                    this.setState({
                        rightView: 4
                    });
                    this.markActive(parseInt(4));
                }
            }
            
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.getCoinRateInfoAndAuth();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth});

    };

    getCoinRateInfoAndAuth = () => {
        xhrGetCoinRateInfoAndAuth({}, this.getCoinRateInfoAndAuthSuccess, this.getCoinRateInfoAndAuthFailure);
    };

    getCoinRateInfoAndAuthSuccess = (authData, coinInfo) => {
        let coinRate = coinInfo && coinInfo.coin_rate;
        if(authData) {
            this.setState({
                isAuthenticatedUser: true,
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS,
                coinRate
            });
        }
        else {
            this.setState({
                serverCallStatus: Constants.REQUEST_STATS.SUCCESS,
                coinRate
            });
        }
    };

    getCoinRateInfoAndAuthFailure = () => {
        this.setState({
            serverCallStatus: Constants.REQUEST_STATS.SUCCESS
        });
    };

    markActive = (value) => {
        window.scrollTo(0, 0);
        switch (value) {

            case 1: this.setState({
                isActiveQuestion1: true,
                isActiveQuestion5: false
            });
                break;
            case 2: this.setState({
                isActiveQuestion1: false,
                isActiveQuestion5: false
            });
                break;
            case 3: this.setState({
                isActiveQuestion1: false,
                isActiveQuestion5: false
            });
                break;
            case 4: this.setState({
                isActiveQuestion1: false,
                isActiveQuestion5: false
            });
                break;
            case 5: this.setState({
                isActiveQuestion1: false,
                isActiveQuestion5: true
            });
                break;
            default:
                break;

        }
    };

    onCrossClickGetMoreProfile = () => {
        this.setState({
            showGetMoreProfilesModal: false,
            type: null
        });
    };

    onClickQuestion = (rightView) => {
        this.setState({
            rightView: parseInt(rightView)
        });
        this.markActive(parseInt(rightView));
    };

    onClickLinks = (value) => {
        switch(value) {
            case Constants.FAQ_LINKS_REDIRECT.PREMIUM_FEATURE_SECTION:
                this.onClickQuestion(3);
            break;
            case Constants.FAQ_LINKS_REDIRECT.START_HIRING:
                window.open("/hire");
            break;
            case Constants.FAQ_LINKS_REDIRECT.POST_A_JOB:
                window.open("/postajob");
            break;
            case Constants.FAQ_LINKS_REDIRECT.JOBS_LISTING_PAGE:
                window.open("/jobs");
            break;
        }
    }

    onClickButtonForFaq = (value, type) => {
        
        if(value === Constants.FAQ_BUTTON.CONTACT_US) {
            window && window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.floatwindow && window.$zoho.salesiq.floatwindow.visible && window.$zoho.salesiq.floatwindow.visible('show');
        }else if(value === Constants.FAQ_BUTTON.START_HIRING) {
            window.open("/hire");
        }else if(value === Constants.FAQ_BUTTON.POST_A_JOB) {
            window.open("/postajob");
        }else if(value === Constants.FAQ_BUTTON.KNOW_MORE) {
            this.setState({
                showGetMoreProfilesModal: true,
                type
            });
        }
        return false
        
    };

    onClickGetInTouch = () => {
        window.scrollTo(0, this.refGetInTouch.offsetTop ? this.refGetInTouch.offsetTop-60 : 0);
    };

    // ------------------------------ View ----------------------------------

    getViewOne = () => {
        return (
            <div>
                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_1}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_1]}
                />
                {/* <Gutter height={10} />
                <Gutter height={10} />
                <BtnOutline
                    customStyle = {btnCustomStyle}
                    onClick = {()=> {this.onClickButtonForFaq(Constants.FAQ_BUTTON.START_HIRING)}}
                    title={Content.BUTTONS.START_HIRING}
                /> */}

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_2}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_2]}
                />

                {/* <Gutter height={10} />
                
                <Gutter height={10} />
                <BtnOutline
                    customStyle = {btnCustomStyle}
                    onClick = {()=> {this.onClickButtonForFaq(Constants.FAQ_BUTTON.CONTACT_US)}}
                    title={Content.BUTTONS.CONTACT_US}
                /> */}

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_3}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_3]}
                />

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_4}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_4]}
                />

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_5}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_5]}
                />

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_6}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_6]}
                />

                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_7}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_7]}
                />

                <Gutter height={20} />

                <BtnOutline
                    customStyle = {btnCustomStyle}
                    onClick = {()=> {this.onClickButtonForFaq(Constants.FAQ_BUTTON.CONTACT_US)}}
                    title={Content.GET_IN_TOUCH.DOUBT_CHAT_NOW}
                />

                <Gutter height={20} />

            </div>
        )
    };

    getViewFive = () => {
        return(
            <div>
                <InformationLabel
                    infoLabel = {Content.FAQ_FREELANCER.QUESTION_5_SUB_QUESTION.QUESTION_1}
                />
                <InformationLabelContentList
                    onClickLinks = {this.onClickLinks}
                    infoLabelContentListContent = {[Content.FAQ_FREELANCER.QUESTION_5_SUB_ANSWER.ANSWER_1]}
                />
                <Gutter height={10} />
                <Gutter height={10} />
                <BtnOutline
                    customStyle = {btnCustomStyle}
                    onClick = {()=> {this.onClickButtonForFaq(Constants.FAQ_BUTTON.CONTACT_US)}}
                    title={Content.BUTTONS.CONTACT_US}
                />
                <Gutter height={400} />
            </div>
        )
    };

    getFaqRightView = () => {
        let renderView = null;
        switch (this.state.rightView) {

            case 1: renderView = this.getViewOne();
                break;
            case 5: renderView = this.getViewFive();
                break;
            default:
                break;

        }

        return renderView;

    };

    getDataView = () => {

        const {
            isActiveQuestion1,
            isActiveQuestion5,
            coinRate
        } = this.state;
        
        let customStyleHeaderText = {
            background: '#0028ea',
            color: '#FFF'
        };

        if(this.state.isAuthenticatedUser) {
            customStyleHeaderText = {
                background: '#F5F5F5',
                color: '#000'
            }
        }

       return (
           <div className="faq">

               <LandingPageHeader
                   isAuthenticatedUser = {this.state.isAuthenticatedUser}
                   onClickGetInTouch = {this.onClickGetInTouch}
                   {...this.props}
               />

               <div style = {{paddingTop: '60px'}}></div>

               <HeaderText
                   headerText = {Content.FAQ_FREELANCER.FAQ}
                   customStyleHeaderText = {customStyleHeaderText}
               />

               {
                   this.state.width > 990 ?

                   <div className="faq-q-and-answer-wrapper">
                       <InformationLabel
                           infoLabel = {Content.FAQ_FREELANCER.STATEMENT_2}
                       />

                       <div className="faq-question-answer">
                           <div className="faq-qa-left">
                               <div>
                                   <InformationLabel
                                       infoLabel = {Content.FAQ_FREELANCER.QUESTION_1}
                                       isActive = {isActiveQuestion1}
                                       id = {"1"}
                                       onClick = {this.onClickQuestion}
                                   />
                                   <InformationLabel
                                       infoLabel = {Content.FAQ_FREELANCER.QUESTION_5}
                                       isActive = {isActiveQuestion5}
                                       id = {"5"}
                                       onClick = {this.onClickQuestion}
                                   />
                               </div>
                           </div>
                           <div className="faq-qa-middle">

                           </div>
                           <div className="faq-qa-right">
                               {this.getFaqRightView()}

                           </div>
                       </div>
                   </div>

                   :

                   <div className="faq-q-and-answer-wrapper-mobile">

                       <InformationLabel
                           infoLabel={Content.FAQ_FREELANCER.FAQ}
                       />

                       <InformationLabel
                           infoLabel={Content.FAQ_FREELANCER.STATEMENT_2}
                       />

                       <div className="faq-question-answer">

                           <InformationLabel
                               infoLabel={Content.FAQ_FREELANCER.QUESTION_1}
                               isActive={true}
                               id={"1"}
                               onClick={this.onClickQuestion}
                           />
                           <div className="faq-qa-right">


                               <div>
                                   <InformationLabel
                                       infoLabel={Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_1}
                                   />
                                   <InformationLabelContentList
                                       infoLabelContentListContent={[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_1]}
                                   />

                                   <InformationLabel
                                       infoLabel={Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_2}
                                   />
                                   <InformationLabelContentList
                                       infoLabelContentListContent={[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_2]}
                                   />

                                   <InformationLabel
                                       infoLabel={Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_3}
                                   />
                                   <InformationLabelContentList
                                       infoLabelContentListContent={[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_3]}
                                   />

                                   <InformationLabel
                                       infoLabel={Content.FAQ_FREELANCER.QUESTION_1_SUB_QUESTION.QUESTION_4}
                                   />
                                   <InformationLabelContentList
                                       infoLabelContentListContent={[Content.FAQ_FREELANCER.QUESTION_1_SUB_ANSWER.ANSWER_4]}
                                   />
                               </div>
                           </div>
                       </div>
                   </div>
               }

                <div ref={ref => this.refGetInTouch=ref}></div>
               {/* <GetInTouch /> */}

               <Footer/>
           </div>
       )
    };

    getLoadingPage = ()=>{
        return(
            <DataPanelLoadingView/>
        );
    };

    getViewTobeRendered = (serverCallStatus) =>{
        let renderView = null ;

        switch (serverCallStatus){
            case 1:
                renderView =  this.getLoadingPage();
                break;
            case 2:
                renderView = this.getDataView();
                break;
            default:
                break;
        }
        return renderView;
    };

    render() {
        const { showGetMoreProfilesModal, type, coinRate } = this.state;
        return (
            <React.Fragment>
                {this.getViewTobeRendered(this.state.serverCallStatus)}
                {
                    showGetMoreProfilesModal?
                    <GetMoreProfilesModal 
                        viewType = {type ==="Boost" ? 3 : 2}  
                        crossClickedHandler = {this.onCrossClickGetMoreProfile}
                        rate = {coinRate}
                    />
                    :
                    null
                }
            </React.Fragment>
            
            )

    }

}

export default FaqFreelancer;



// WEBPACK FOOTER //
// ./src/scenes/FAQ/FaqFreelancer.js